module.exports = __webpack_public_path__ + "static/media/mainimg-06.32b01a4d.png";